import request from './requestWrapper';

// Types
import {PaginationType} from '../types/sharedTypes';
import {InboundType} from '../types/inboundTypes';

function getAll(data: PaginationType) {
  return request({
    url: 'inbound/getAllPaginated',
    method: 'GET',
    params: data
  });
}
function getTemplate() {
  return request({
    url: 'inbound/getTemplate',
    method: 'GET',
  });
}
function upload(formData: FormData) {
  return request({
    url: 'inbound/upload',
    method: 'POST',
    data: formData
  });
}
function update(inbound: InboundType) {
  return request({
    url: 'inbound/update',
    method: 'PUT',
    data: inbound,
  });
}
function remove(inboundId: string) {
  return request({
    url: `inbound/delete/${inboundId}`,
    method: 'DELETE',
  });
}

export default {
  getAll, getTemplate, upload, update, remove
}